export class VisitObjective {
  id: number;
  name: string;
}
